export const translations = {
  en: {
    home: {
      nav: { services: "Services", about: "About", contact: "Contact", cta: "Start a conversation" },
      hero: {
        eyebrow: "TECH CONSULTING · PORTUGAL",
        title: ["Engineering", "trust into every", "connection."],
        subtitle:
          "Polvo Transcendental is an independent consulting practice for information security, cloud architecture and networking — built for teams who refuse to leave resilience to chance.",
        ctaPrimary: "Book a consultation",
        ctaSecondary: "Our services",
      },
      marquee:
        "INFORMATION SECURITY • CLOUD ARCHITECTURE • NETWORK ENGINEERING • ZERO TRUST • RISK ASSESSMENT • INCIDENT RESPONSE • ",
      services: {
        eyebrow: "WHAT WE DO",
        title: "Three disciplines. One perimeter.",
        items: [
          {
            tag: "01",
            title: "Information Security",
            desc: "Threat modelling, penetration testing, compliance audits (ISO 27001, GDPR) and security architecture that holds under pressure.",
          },
          {
            tag: "02",
            title: "Cloud Services",
            desc: "Migration, cost governance and resilient multi-cloud architecture across AWS, Azure and GCP — built to scale without surprises.",
          },
          {
            tag: "03",
            title: "Networking",
            desc: "Enterprise network design, SD-WAN, segmentation and monitoring that keeps every tentacle of your infrastructure connected.",
          },
        ],
      },
      about: {
        eyebrow: "ABOUT US",
        title: "An octopus doesn't panic.",
        paragraph1:
          "Founded in Portugal, Polvo Transcendental was born from a simple observation: complex systems fail not from lack of talent, but from lack of coordination. Like the octopus — three hearts, nine brains, endless reach — we operate with distributed intelligence across every discipline your infrastructure depends on.",
        paragraph2:
          "We work with founders, CTOs and public institutions who need a partner that thinks in systems, not tickets.",
        otherLabel: "OTHER PROJECTS",
        otherTitle: "Polvo Scuba",
        otherDesc:
          "Same name, deeper waters. Our sister project is a dive center and scuba shop on the Portuguese coast.",
        otherCta: "Explore Polvo Scuba",
      },
      manifesto: {
        eyebrow: "HOW WE WORK",
        title: "Four principles. Zero exceptions.",
        items: [
          { num: "01", title: "Listen first", desc: "Every engagement starts with an audit of reality, not assumptions." },
          { num: "02", title: "Design for failure", desc: "We architect systems that degrade gracefully, never catastrophically." },
          { num: "03", title: "Stay accountable", desc: "No hand-offs into the void — we remain reachable long after go-live." },
          { num: "04", title: "Measure everything", desc: "If it isn't measured, it isn't secured." },
        ],
      },
      contact: {
        eyebrow: "GET IN TOUCH",
        title: "Let's tighten your perimeter.",
        subtitle: "Tell us about your infrastructure, timeline and constraints. We reply within one business day.",
        form: {
          name: "Full name",
          email: "Email address",
          company: "Company",
          message: "Tell us about your project",
          submit: "Send message",
          success: "Message sent — we'll be in touch soon.",
          error: "Something went wrong. Please try again.",
        },
      },
      footer: {
        tagline: "Information security, cloud & networking consulting, from Portugal to the world.",
        location: "Lisbon, Portugal",
        rights: "© 2026 Polvo Transcendental. All rights reserved.",
      },
    },
    scuba: {
      nav: { about: "About", services: "Services", gallery: "Gallery", contact: "Contact", cta: "Book a dive", back: "Polvo Transcendental" },
      hero: {
        eyebrow: "DIVE CENTER & SCUBA SHOP",
        title: ["Descend", "into the", "blue."],
        subtitle:
          "Polvo Scuba is a dive center and scuba shop on the Portuguese coast — courses, guided dives and gear for every depth.",
        ctaPrimary: "Book a dive",
        ctaSecondary: "See courses",
      },
      about: {
        eyebrow: "ABOUT POLVO SCUBA",
        title: "Same octopus. Deeper waters.",
        paragraph:
          "Polvo Scuba grew out of Polvo Transcendental's love for systems that connect — the ocean being the original network. We offer certifications from Open Water to Divemaster, alongside a curated scuba shop for gear that lasts.",
      },
      services: {
        eyebrow: "WHAT WE OFFER",
        title: "Courses, gear and guided depths.",
        items: [
          { tag: "01", title: "Dive Courses", desc: "Certifications from first breath underwater to professional levels — small groups, patient instructors." },
          { tag: "02", title: "Scuba Shop", desc: "Curated regulators, BCDs, wetsuits and accessories from trusted brands, fitted and serviced in-house." },
          { tag: "03", title: "Guided Dives & Trips", desc: "Reef dives, wreck explorations and Mediterranean excursions guided by local dive masters." },
        ],
      },
      gallery: { eyebrow: "BENEATH THE SURFACE", title: "A world you can only earn." },
      contact: {
        eyebrow: "PLAN YOUR DIVE",
        title: "Ready to get wet?",
        subtitle: "Ask about courses, trips or gear — we'll help you find the right depth.",
        form: {
          name: "Full name",
          email: "Email address",
          message: "Tell us what you're looking for",
          submit: "Send message",
          success: "Message sent — we'll be in touch soon.",
          error: "Something went wrong. Please try again.",
        },
      },
      footer: {
        tagline: "Dive center & scuba shop on the Portuguese coast.",
        rights: "© 2026 Polvo Scuba — a Polvo Transcendental project.",
      },
    },
  },
  pt: {
    home: {
      nav: { services: "Serviços", about: "Sobre", contact: "Contacto", cta: "Iniciar conversa" },
      hero: {
        eyebrow: "CONSULTORIA TECNOLÓGICA · PORTUGAL",
        title: ["A engenharia", "da confiança em", "cada ligação."],
        subtitle:
          "A Polvo Transcendental é uma consultoria independente em segurança da informação, arquitetura cloud e redes — para equipas que não deixam a resiliência ao acaso.",
        ctaPrimary: "Marcar consulta",
        ctaSecondary: "Os nossos serviços",
      },
      marquee:
        "SEGURANÇA DA INFORMAÇÃO • ARQUITETURA CLOUD • ENGENHARIA DE REDES • ZERO TRUST • ANÁLISE DE RISCO • RESPOSTA A INCIDENTES • ",
      services: {
        eyebrow: "O QUE FAZEMOS",
        title: "Três disciplinas. Um só perímetro.",
        items: [
          {
            tag: "01",
            title: "Segurança da Informação",
            desc: "Modelação de ameaças, testes de intrusão, auditorias de conformidade (ISO 27001, RGPD) e arquitetura de segurança que resiste à pressão.",
          },
          {
            tag: "02",
            title: "Serviços Cloud",
            desc: "Migração, governação de custos e arquitetura multi-cloud resiliente em AWS, Azure e GCP — pensada para escalar sem surpresas.",
          },
          {
            tag: "03",
            title: "Redes",
            desc: "Desenho de redes empresariais, SD-WAN, segmentação e monitorização que mantém cada tentáculo da sua infraestrutura ligado.",
          },
        ],
      },
      about: {
        eyebrow: "SOBRE NÓS",
        title: "Um polvo não entra em pânico.",
        paragraph1:
          "Fundada em Portugal, a Polvo Transcendental nasceu de uma observação simples: sistemas complexos falham não por falta de talento, mas por falta de coordenação. Como o polvo — três corações, nove cérebros, alcance infinito — operamos com inteligência distribuída em cada disciplina de que a sua infraestrutura depende.",
        paragraph2:
          "Trabalhamos com fundadores, CTOs e instituições públicas que precisam de um parceiro que pensa em sistemas, não em tickets.",
        otherLabel: "OUTROS PROJETOS",
        otherTitle: "Polvo Scuba",
        otherDesc:
          "O mesmo nome, águas mais profundas. O nosso projeto irmão é um centro de mergulho e loja de equipamentos  na costa portuguesa.",
        otherCta: "Explorar a Polvo Scuba",
      },
      manifesto: {
        eyebrow: "COMO TRABALHAMOS",
        title: "Quatro princípios. Zero excepções.",
        items: [
          { num: "01", title: "Ouvir primeiro", desc: "Cada projeto começa com uma auditoria à realidade, não a suposições." },
          { num: "02", title: "Desenhar para a falha", desc: "Concebemos sistemas que degradam com elegância, nunca de forma catastrófica." },
          { num: "03", title: "Manter responsabilidade", desc: "Sem entregas para o vazio — continuamos acessíveis muito depois do lançamento." },
          { num: "04", title: "Medir tudo", desc: "Se não é medido, não está protegido." },
        ],
      },
      contact: {
        eyebrow: "FALE CONNOSCO",
        title: "Vamos apertar o seu perímetro.",
        subtitle: "Conte-nos sobre a sua infraestrutura, prazos e restrições. Respondemos em um dia útil.",
        form: {
          name: "Nome completo",
          email: "Endereço de email",
          company: "Empresa",
          message: "Conte-nos sobre o seu projeto",
          submit: "Enviar mensagem",
          success: "Mensagem enviada — entraremos em contacto brevemente.",
          error: "Ocorreu um erro. Por favor tente novamente.",
        },
      },
      footer: {
        tagline: "Consultoria em segurança da informação, cloud e redes, de Portugal para o mundo.",
        location: "Lisboa, Portugal",
        rights: "© 2026 Polvo Transcendental. Todos os direitos reservados.",
      },
    },
    scuba: {
      nav: { about: "Sobre", services: "Serviços", gallery: "Galeria", contact: "Contacto", cta: "Marcar mergulho", back: "Polvo Transcendental" },
      hero: {
        eyebrow: "CENTRO DE MERGULHO & SCUBA SHOP",
        title: ["Descer", "até ao", "azul."],
        subtitle:
          "A Polvo Scuba é um centro de mergulho e loja de equipamentos  na costa portuguesa — cursos, mergulhos guiados e equipamento para todas as profundidades.",
        ctaPrimary: "Marcar mergulho",
        ctaSecondary: "Ver cursos",
      },
      about: {
        eyebrow: "SOBRE A POLVO SCUBA",
        title: "O mesmo polvo. Águas mais profundas.",
        paragraph:
          "A Polvo Scuba nasceu do gosto da Polvo Transcendental por sistemas que ligam — sendo o oceano a rede original. Oferecemos certificações desde o Open Water até Divemaster, e uma loja de equipamentos  com equipamento que dura.",
      },
      services: {
        eyebrow: "O QUE OFERECEMOS",
        title: "Cursos, equipamento e profundidades guiadas.",
        items: [
          { tag: "01", title: "Cursos de Mergulho", desc: "Certificações desde a primeira respiração debaixo de água até níveis profissionais — grupos pequenos, instrutores pacientes." },
          { tag: "02", title: "Scuba Shop", desc: "Reguladores, coletes, fatos e acessórios selecionados de marcas de confiança, ajustados e revistos internamente." },
          { tag: "03", title: "Mergulhos e Viagens Guiadas", desc: "Mergulhos em recifes, exploração de destroços e excursões mediterrânicas guiadas por mestres de mergulho locais." },
        ],
      },
      gallery: { eyebrow: "SOB A SUPERFÍCIE", title: "Um mundo que só se conquista." },
      contact: {
        eyebrow: "PLANEIE O SEU MERGULHO",
        title: "Pronto para se molhar?",
        subtitle: "Pergunte sobre cursos, viagens ou equipamento — ajudamos a encontrar a profundidade certa.",
        form: {
          name: "Nome completo",
          email: "Endereço de email",
          message: "Diga-nos o que procura",
          submit: "Enviar mensagem",
          success: "Mensagem enviada — entraremos em contacto brevemente.",
          error: "Ocorreu um erro. Por favor tente novamente.",
        },
      },
      footer: {
        tagline: "Centro de mergulho e loja de equipamentos  na costa portuguesa.",
        rights: "© 2026 Polvo Scuba — um projeto Polvo Transcendental.",
      },
    },
  },
};
